import { required } from 'react-admin';

export const tipoValidacao = [required('Selecione um tipo')];

export const tipoOpcoes = [
	{ id: 'F', name: 'Física' },
	{ id: 'J', name: 'Jurídica' },
];
